import { render, staticRenderFns } from "./HowToCancel.vue?vue&type=template&id=5c570ebc&scoped=true&"
import script from "./HowToCancel.vue?vue&type=script&lang=js&"
export * from "./HowToCancel.vue?vue&type=script&lang=js&"
import style0 from "./HowToCancel.vue?vue&type=style&index=0&id=5c570ebc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c570ebc",
  null
  
)

export default component.exports